
export const InnerEvent = {
  DEMUXED_TRACK: 'demuxedtrack'
}
